export default "__VITE_ASSET__CUZEjBXC__"